import { render, staticRenderFns } from "./realData.vue?vue&type=template&id=685bf222&"
import script from "./realData.vue?vue&type=script&lang=js&"
export * from "./realData.vue?vue&type=script&lang=js&"
import style0 from "./realData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports